"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * NWG.Commerce.Microshop - Api
 * NWG.Commerce.Microshop - Api functionality
 *
 * The version of the OpenAPI document: NWG.Commerce.Microshop - Api
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResetPasswordModelToJSON = exports.ResetPasswordModelFromJSONTyped = exports.ResetPasswordModelFromJSON = exports.instanceOfResetPasswordModel = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the ResetPasswordModel interface.
 */
function instanceOfResetPasswordModel(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfResetPasswordModel = instanceOfResetPasswordModel;
function ResetPasswordModelFromJSON(json) {
    return ResetPasswordModelFromJSONTyped(json, false);
}
exports.ResetPasswordModelFromJSON = ResetPasswordModelFromJSON;
function ResetPasswordModelFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'email': !(0, runtime_1.exists)(json, 'email') ? undefined : json['email'],
    };
}
exports.ResetPasswordModelFromJSONTyped = ResetPasswordModelFromJSONTyped;
function ResetPasswordModelToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'email': value.email,
    };
}
exports.ResetPasswordModelToJSON = ResetPasswordModelToJSON;
